import { setRangeMin } from './helpers';
import { FOfferType, TJsonQuery } from './types';
import { offerTypeFromJsonQuery } from './utils/offerTypeFromJsonQuery';

export const setTotalAreaMin =
  (jsonQuery: TJsonQuery) =>
  (gte: number | null): TJsonQuery => {
    const offerType = offerTypeFromJsonQuery(jsonQuery);
    const field = (offerType & FOfferType.CommercialLand) !== 0 ? 'site' : 'total_area';

    return setRangeMin(field)(jsonQuery)(gte);
  };
